import * as React from "react";
import { FC } from "react";
import { Edit, EditProps } from "react-admin";
import AircraftTypeEditForm from "./Forms/AircraftTypeEditForm";
import { TitleAircraftType } from "./Constant/Source";

const AircraftTypeEdit: FC<EditProps> = props => {
  return (
    <Edit {...props} title={TitleAircraftType.edit} component="div">
      <AircraftTypeEditForm {...props} />
    </Edit>
  );
};

export default AircraftTypeEdit;
